/*
 * @author Dallas Yan (@dallasyan)
 */
import { useEffect, useState } from "react";
import entryTestClient from "../client/EntryTestClient";
export const useSubjectsRequiringTest = (): string[] => {
    const [subjects, setSubjects] = useState<string[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            setSubjects(await entryTestClient.getEntrytestSubjectNames());
        };
        fetchData().catch(console.error);
    }, []);

    return subjects;
};
